import { render, staticRenderFns } from "./HouseTypeResultList.vue?vue&type=template&id=5513a632"
import script from "./HouseTypeResultList.vue?vue&type=script&lang=js"
export * from "./HouseTypeResultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports